import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionToolbar = ({ selectedCount, onSendBulkMessage, onExportClients, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4">
      <div className="bg-card border border-border rounded-lg shadow-warm-lg p-4 min-w-[320px] md:min-w-[480px]">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full">
              <span className="text-sm font-semibold text-primary font-data">{selectedCount}</span>
            </div>
            <span className="text-sm font-medium text-foreground">
              تم تحديد {selectedCount} عميل
            </span>
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="default"
              size="sm"
              iconName="Send"
              iconPosition="right"
              onClick={onSendBulkMessage}
            >
              إرسال رسالة جماعية
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="right"
              onClick={onExportClients}
            >
              تصدير
            </Button>
            <button
              onClick={onClearSelection}
              className="p-2 hover:bg-muted rounded-lg transition-colors"
              aria-label="إلغاء التحديد"
            >
              <Icon name="X" size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionToolbar;